/**
 * Accès localStorage résistant aux navigateurs privacy (Ecosia, Brave, etc.)
 * qui peuvent lever SecurityError si le stockage site est bloqué.
 */

export function browserStorageGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function browserStorageSet(key: string, value: string): boolean {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function browserStorageRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function isBrowserStorageAvailable(): boolean {
  try {
    const probe = '__sherlook_storage_probe__';
    localStorage.setItem(probe, '1');
    localStorage.removeItem(probe);
    return true;
  } catch {
    return false;
  }
}

/** Message UX quand l’API est injoignable (bloqueur / CORS / offline). */
export function formatApiReachabilityError(err: unknown): string | null {
  const ax = err as {
    code?: string;
    message?: string;
    response?: unknown;
  };
  if (ax?.response) return null;
  const msg = String(ax?.message || '').toLowerCase();
  const code = String(ax?.code || '');
  if (
    code === 'ERR_NETWORK' ||
    code === 'ECONNABORTED' ||
    msg.includes('network error') ||
    msg.includes('failed to fetch')
  ) {
    return (
      'Impossible de joindre le serveur. Sur Ecosia (ou Brave) : cliquez le bouclier dans la barre d’adresse, ' +
      'autorisez le site et l’API (dashboard.sherlook.fr / api26.sherlook.fr), ' +
      'désactivez le blocage pubs/trackers pour ce site, puis réessayez.'
    );
  }
  return null;
}
